function ProgressBar() {
    return (
        <div className="bg-pink-300 w-12 h-3 ml-5 my-1">
            <div className="h-3 w-32 border-2 border-solid shadow-neutral-800 shadow-inner drop-shadow-xl" >

            </div>
        </div>
    )
}

export default ProgressBar
